export default __webpack_public_path__ + "static/media/Google.7a80b4e7.png";